import * as swcHelpers from '@swc/helpers';
import { getLocalizedString, isDefined } from '@grandvisionhq/utils';
import { getCLMetaTitle } from '../utils/get-product-seo-info.js';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapToPrescriptionRanges } from '../utils/map-to-prescription-ranges.js';
import { getContactLensProductFeatures } from '../utils/product-feature-mappers/get-contact-lens-product-features.js';
import { mapServerToContactLensesSpecifications } from '../specification-mappers/map-server-to-contact-lenses-specifications.js';
import { mapServerToVariantBase } from './map-server-to-variant-base.js';

const mapServerToContactLensVariant = (serverProduct, slug, locale)=>{
    const { variants: serverVariants  } = serverProduct;
    if (!serverVariants || !serverVariants.length) {
        return;
    }
    const clientVariants = serverVariants.map((serverVariant)=>{
        const variantBase = mapServerToVariantBase(serverVariant, serverProduct, slug, locale);
        if (!variantBase) return;
        const { variantTypeDetails  } = serverVariant;
        const { color , opticalRanges , subscriptionIntervals  } = variantTypeDetails;
        const { brand  } = serverProduct;
        const { replacementFrequencyAllLocales  } = serverProduct.productTypeDetails;
        const colorDisplayName = Array.isArray(color) ? color.join(' / ') : color;
        const productFeatures = getContactLensProductFeatures(variantTypeDetails);
        const replacementFrequency = getLocalizedString(replacementFrequencyAllLocales, locale);
        const metaTitle = getCLMetaTitle(serverVariant, serverProduct, replacementFrequency);
        const specifications = mapServerToContactLensesSpecifications(serverVariant, brand, replacementFrequency, replacementFrequencyAllLocales);
        const prescriptionRanges = mapToPrescriptionRanges(opticalRanges);
        if (!prescriptionRanges || !prescriptionRanges.length) {
            console.error(`Required prescription ranges not provided for Contact Lens`, {
                slug,
                sku: variantBase.sku
            });
        }
        if (!!(prescriptionRanges === null || prescriptionRanges === void 0 ? void 0 : prescriptionRanges.length) && !prescriptionRanges.some((attr)=>attr.name === 'power'
        )) {
            console.error(`Required Power prescription range not provided for Contact Lens`, {
                slug,
                sku: variantBase.sku
            });
        }
        var _lensType;
        const clientVariant = swcHelpers.objectSpread({}, variantBase, {
            variantType: 'contact-lens',
            prescriptionRanges,
            isMasterProduct: variantTypeDetails.isMaster,
            masterVariantSku: variantTypeDetails.masterVariantSku,
            lensesPerBox: variantTypeDetails.packageQuantity,
            lensType: (_lensType = variantTypeDetails.lensType) !== null && _lensType !== void 0 ? _lensType : undefined,
            replacementFrequency,
            facets: {
                color: !!colorDisplayName ? colorDisplayName : undefined
            },
            specifications,
            productFeatures,
            seoConfig: swcHelpers.objectSpread({}, variantBase.seoConfig, {
                metaTitle
            }),
            availableSubscriptionIntervals: subscriptionIntervals
        });
        return clientVariant;
    });
    return clientVariants.filter(isDefined);
};

export { mapServerToContactLensVariant };
//# sourceMappingURL=map-server-to-contact-lens-variant.js.map
